import React from 'react'
import PropTypes from 'prop-types'

import styled, { css } from 'styled-components'

const propTypes = {
  isSelected: PropTypes.bool,
  series: PropTypes.shape().isRequired,
  disable: PropTypes.bool.isRequired,
  onSelectSeriesCallback: PropTypes.func,
  className: PropTypes.string
}

const defaultProps = {
  isSelected: false,
  className: '',
  onSelectSeriesCallback: () => {}
}

const SeriesLabel = ({ isSelected, disable, series, className, onSelectSeriesCallback }) => {
  const onClickLabel = () => {
    if (!disable) {
      onSelectSeriesCallback(series.seriesName, !isSelected)
    }
  }

  return (
    <S.Label {...{ isSelected, className, disable }} onClick={onClickLabel}>
      {series.icon
        ? series.icon
        : (
          <svg width="30px" height="6px" xmlns="http://www.w3.org/2000/svg">
            <line
                x1={series.x1}
                y1={series.y1}
                x2={series.x2}
                y2={series.y2}
                stroke={series.stroke}
                strokeWidth={series.strokeWidth}
                strokeDasharray={series.strokeDasharray}
                strokeLinecap={series.strokeLineCap}
            />
          </svg>
        )
      }

      <span>{series.label}</span>
    </S.Label>
  )
}

export default SeriesLabel

SeriesLabel.propTypes = propTypes
SeriesLabel.defaultProps = defaultProps

const S = {
  Label: styled.span.withConfig({
    shouldForwardProp: (prop) => !['isSelected', 'disable'].includes(prop)
  })`
    display: inline-block;
    cursor: pointer;
    ${({ disable }) => (disable && css`
      opacity: 0.4;
      pointer-events: none;
    `)}

    ${({ isSelected, disable }) =>
    (
      isSelected && !disable
        ? css`font-weight: bold;`
        : css`letter-spacing: .31px;

          &:hover {
            letter-spacing: normal;
            font-weight: 600;
          }
        `
    )}
`
}
